const ServicesHero = () => {
  return (
    <section className="relative pt-32 pb-20 px-4 md:px-8 overflow-hidden bg-[#1c2e0f]">
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <span className="inline-block bg-[#7ab648]/20 border border-[#7ab648]/40 text-[#a8d96b] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">
          K9 Mold Detection Services
        </span>
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-5">Our Services</h1>
        <p className="text-white/70 text-lg leading-relaxed max-w-2xl mx-auto">
          Professional K9 mold detection for Western New York homeowners. Fast, accurate, and non-invasive. Submit a request and we&apos;ll reach out with a quote.
        </p>
      </div>
    </section>
  );
};

export default ServicesHero;